
    import Vue from 'vue';
    import documentTypeService from '@/apps/shared/services/documentType-service';
    import localityService from '@/apps/shared/services/locality-service';
    import CRMCotizadorWebService from '@/apps/shared/services/crm-service';
    import phoneValidateService from '@/apps/shared/services/phone-service';
    import FilePathService from '@/apps/shared/services/filePath-service';
    import searchPersonService from '@/apps/shared/services/searchPerson-service';
    export default Vue.extend({
        el: '#step1',
        name: 'TabOne',
        data() {
            return {
                localityList:
                    function (params) {
                        return localityService.getLocalityList(params)
                    },
                telephone: '',
                streetName: null,
                nacimiento: null,
                messageErrorAge: null,
                age: '0',
                stringDate: '',
                piso: null,
                numDom: null,
                numDept: null,
                areaCode: '',
                email: '',
                numDoc: null,
                selectedLocality: null,
                cityName: null,
                cityId2: null,
                localityId: null,
                zipCode: null,
                Procesoautomatico: false,
                documentTypeList: [{ id: "", text: "" }],
                MaximDigitSuperatedDni: false,
                isPersonExist: false,
                isNotSelectedDocumentType: true,
                docTypeSelected: null,
                maxSelections: 2,
                activeForm: false,
                minimumInputLength: 4,
                autocompleteConfig: {
                    formatResult: NF.Autocomplete.Result.TAGS,
                    selection: NF.Autocomplete.Result.TAGS,
                    minimumInputLength: 4
                },
                accept: true,
                DataPlan: null,
                planDescription: null,
                primerCuota: null,
                gender: null,
                officeId: null,
                city: null,
                address: null,
                selectedIvaCondition: null,
                province: null,
                genderId: null,
                firstName: "",
                lastName: "",
                activeFormPersonNoExist: false,
                hasLocality: false,
                localityIsSelected: true,
                disable: true,
                validatePhone: false,
                messageErrorAreaCode: null,
                messageErrorPhone: null,
                messageError: null,
                messageErrorDigits: null,
                validDigits: null,
                numDocChange: null,
                numDocExisting: null
            }
        },

        created() {
            window.globalThis.validateNumDoc = (val) => {
                let valid = true
                let message = ""
                if (this.docTypeSelected.id == 'D' && val.length != 7 && val.length != 8) {
                    this.disable = true;
                    if (val.length > 0) {
                        valid = false
                        message = "La cantidad de dígitos es incorrecto"
                    }
                    else {
                        valid = false
                        message = "Este campo es obligatorio."
                    }
                } else if (this.docTypeSelected.id == 'D' && (val.length == 7 || val.length == 8)) {
                    if (this.numDocExisting != val) {
                        this.numDocChange = true;
                        this.numDocExisting = val;
                    }

                    this.disable = false;
                    message = "";
                    valid = true;
                }
                else {
                    this.disable = false;
                }
                return {
                    valid,
                    message
                }
            };

            window.globalThis.validateLocality = function () {
                return Boolean(this.selectedLocality);
            }.bind(this);
        },

        methods: {
            searchPersonData() {
                this.streetName = null;
                this.piso = null;
                this.numDom = null;
                this.numDept = null;
                this.selectedLocality = null;
                this.getPersonByDocumentAndType();
            },

            getTelephoneValidation() {
                return new Promise<any>(async (resolve) => {
                    await this.validPhone()
                });
            },

            getFilePath() {
                FilePathService.getFilePath("UrlBase")
                    .then(response => {
                        window.location.href = response + "electronic-equipment/elegiPlan";
                    });
            },

            validate: function (config, direction) {
                if (direction == "backward") {
                    sessionStorage.setItem("ExitOrContinueModal", "false");
                    this.getFilePath();
                    return true
                }
                document.getElementById("Anterior").style.visibility = "visible"
                document.getElementById("Siguiente").style.visibility = "visible"
                if (!this.numDocChange) {
                    var formIsValid = NF.Validation.Form.validate('#form1');
                    if (!formIsValid) {
                        return formIsValid;
                    }
                    if (!this.hasLocality && config.viewModel.selectedLocality == null) {
                        this.localityIsSelected = false;
                        return false
                    }
                    if (direction != "backward") {
                        sessionStorage.removeItem("stepOneData");
                        var birthDay = new Date(config.viewModel.nacimiento.toString());
                        var birthDayFormated = (birthDay.getFullYear() + '/' + (birthDay.getMonth() + 1 + '/' + birthDay.getDate()));
                        sessionStorage.setItem("stepOneData", JSON.stringify({
                            documentType: config.viewModel.docTypeSelected,
                            documentNumber: config.viewModel.numDoc,
                            birthDay: birthDayFormated,
                            areaCode: config.viewModel.areaCode,
                            telephone: config.viewModel.telephone,
                            email: config.viewModel.email,
                            firstName: config.viewModel.firstName,
                            lastName: config.viewModel.lastName,
                            zipCode: (!this.isPersonExist || !this.hasLocality) ? config.viewModel.selectedLocality.zipCode : null,
                            localityId: (!this.isPersonExist || !this.hasLocality) ? config.viewModel.selectedLocality.id : null,
                            streetName: config.viewModel.streetName,
                            piso: config.viewModel.piso,
                            numDom: config.viewModel.numDom,
                            numDept: config.viewModel.numDept
                        }));
                        this.validPhone();
                        return this.age < 18 ? false : true;
                    } else {
                        return formIsValid;
                    }
                } else {
                    this.searchPersonData();
                    return false;
                }
            },

            createOrEditLead: function () {
                CRMCotizadorWebService.CreateOrEditLead(this.email, location.href, this.areaCode, this.telephone, 1000, false, "5");
            },

            validPhone: function () {
                if (this.telephone == "" && this.areaCode == "") {
                    this.validDigits = true;
                }
                return new Promise<any>(async (resolve) => {
                    await phoneValidateService.validatePhone(this.areaCode, this.telephone).then(o => {
                        if (o.areaCodeSuccess == false) {
                            this.messageErrorAreaCode = o.message
                        }
                        if (o.phoneNumberSuccess == false) {
                            this.messageErrorPhone = o.message
                        }
                        if (o.validCountDigit != null) {
                            if (o.validCountDigit) {
                                this.messageErrorDigits = "";
                            }
                            else {
                                this.messageErrorDigits = o.message
                            }
                        }
                        else {
                            this.messageErrorDigits = "";
                        }
                        this.validatePhone = o.validCountDigit;
                        resolve(true);
                    });
                })
            },

            getDocumentType() {
                documentTypeService.getDocumentTypeList().then(response => {
                    if (response.length != 0) {
                        this.documentTypeList = response.map(element =>
                            ({ ...element, id: element["id"], text: element["name"] }))
                        this.docTypeSelected = this.documentTypeList.find(p => p.name.trim() == "DNI");
                    }
                })
            },

            getPersonByDocumentAndType: function () {
                this.numDocChange = false;
                document.getElementById("StepText").textContent = "Contratar";
                document.getElementById("Siguiente").style.visibility = "visible"
                this.activeFormPersonNoExist = false;
                this.hasLocality = false;
                var dataClientTabOne = this.DataPlan = JSON.parse(sessionStorage.getItem("TabOneWelcome"));
                NF.UI.Page.blockCustom({ message: 'Cargando datos..' });
                if (this.numDoc != "") {
                    var Dni = this.numDoc == null ? 0 : this.numDoc;
                    var DocTypeSeleccionado = this.docTypeSelected.name.trim();
                    searchPersonService.GetSearchPersonData(this.numDoc, this.docTypeSelected.id)
                        .then(response => {
                            let result = response.searchPersonResult[0];
                            if (result != undefined && (result && result.firstName != "" && result.lastName != "" || result.razonSocial != undefined)) {
                                this.activeFormPersonNoExist = false;
                                this.isPersonExist = true;
                                this.activeForm = true;
                                this.nacimiento = result.birthday;
                                this.firstName = result.firstName;
                                this.lastName = result.lastName;
                                this.email = dataClientTabOne.email;
                                this.areaCode = dataClientTabOne.areaCode;
                                this.telephone = dataClientTabOne.telephone;
                                this.hasLocality = result.hasLocality;
                                window.globalThis.dataLayer.push({ 'product': 'tecnologia', 'event': 'cotizador-tecnologia-dni' });
                            }
                            else {
                                this.activeForm = true;
                                this.isPersonExist = false;
                                this.firstName = dataClientTabOne.name;
                                this.email = dataClientTabOne.email;
                                this.areaCode = dataClientTabOne.areaCode;
                                this.telephone = dataClientTabOne.telephone;
                                this.age = "";
                                this.nacimiento = null;
                                this.lastName = dataClientTabOne.lastName;
                                this.activeFormPersonNoExist = true;
                                this.selectedLocality = null;
                                window.globalThis.dataLayer.push({ 'product': 'tecnologia', 'event': 'errorUsuario', 'paso': 'cotizador-tecnologia-dni' });
                            }
                            if (Dni.toString().length > 0 && Dni.toString().length < 9) {
                                this.MaximDigitSuperatedDni = false;
                            }
                            else {
                                if (DocTypeSeleccionado == "DNI") {
                                    this.MaximDigitSuperatedDni = true;
                                    this.firstName = "";
                                    this.lastName = "";
                                    this.nacimiento = null;
                                    this.isPersonExist = true;
                                    this.isNotSelectedDocumentType = false
                                    this.age = "";
                                }
                                else {
                                    this.MaximDigitSuperatedDni = true;
                                }
                            }
                        }).then(() => NF.UI.Page.unblock());
                }
                else {
                    this.activeForm = false;
                    this.activeFormPersonNoExist = false;
                    this.nacimiento = null;
                    this.areaCode = "";
                    this.telephone = "";
                    this.email = "";
                    this.age = "0";
                    this.selectedLocality = null;
                    this.streetName = null;
                    this.numDept = null;
                    this.numDom = null;
                    this.piso = null;
                    this.gender = null;
                    this.genderId = null;
                    this.isPersonExist = true;
                    this.isNotSelectedDocumentType = false;
                    this.firstName = "";
                    this.lastName = "";
                    this.hasLocality = false;
                    NF.UI.Page.unblock();
                }
            },

            CleanPersonDataForm: function () {
                if (this.numDoc == "") {
                    NF.UI.Page.blockCustom({ message: 'Limpiando datos..' });
                    this.activeForm = false;
                    this.activeFormPersonNoExist = false;
                    this.nacimiento = null;
                    this.areaCode = "";
                    this.telephone = "";
                    this.email = "";
                    this.age = "0";
                    this.selectedLocality = null;
                    this.streetName = null;
                    this.numDept = null;
                    this.numDom = null;
                    this.piso = null;
                    this.gender = null;
                    this.genderId = null;
                    this.isPersonExist = true;
                    this.isNotSelectedDocumentType = false;
                    this.firstName = "";
                    this.lastName = "";
                    this.hasLocality = false;
                    NF.UI.Page.unblock();
                }
            },

            isSelectedDocumentType: function () {
                this.isNotSelectedDocumentType = false
                this.docTypeSelected != null ? this.docTypeSelected.name.trim() != "CUIT" ? (this.isPerson = true, this.isJuridico = false) : (this.isJuridico = true, this.isPerson = false) : null
                this.nacimiento = null;
                this.numDoc = ""
                this.piso = "";
                this.numDept = "";
                this.numDom = "";
                this.streetName = null;
                this.isPersonExist = true;
                this.hasLocality = false;
            },


            calcularEdad: function () {
                this.messageErrorAge = ""
                if (this.nacimiento != null && this.nacimiento != "") {
                    var today = new Date();
                    if (this.nacimiento.toString().length > 11) {
                        var birthDate = new Date(this.nacimiento);
                        var age = today.getFullYear() - birthDate.getFullYear();
                        var m = today.getMonth() - birthDate.getMonth();
                        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                            age--;
                        }
                        this.age = age;
                        if (this.age < 18) {
                            this.messageErrorAge = "La persona debera ser mayor de 18 años"
                        }
                        else {
                            this.messageErrorAge = ""
                        }
                    }
                    else {
                        var dateFormated = this.nacimiento.split('/')[1] + "/" + this.nacimiento.split('/')[0] + "/" + this.nacimiento.split('/')[2];
                        var birthDate = new Date(dateFormated);
                        var age = today.getFullYear() - birthDate.getFullYear();
                        var m = today.getMonth() - birthDate.getMonth();
                        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                            age--;
                        }
                        this.age = age;
                        if (this.age < 18) {
                            this.messageErrorAge = "La persona deberá ser mayor de 18 años"
                        }
                        else {
                            this.messageErrorAge = ""
                        }
                    }
                }
                else {
                    this.age = 0;
                }
            }
        },

        watch: {
            nacimiento(newVal) {
                if (newVal != null || newVal != "") {
                    this.calcularEdad();
                }
            },
            selectedLocality(newVal) {
                if (this.selectedLocality != null) {
                    this.localityIsSelected = true;
                }
            },
            areaCode(newVal) {
                if (newVal != null && newVal != "") {
                    this.getTelephoneValidation();
                    this.messageErrorDigits = "";
                }
                else {
                    this.messageErrorDigits = "";
                }
            },
            telephone(newVal) {
                if (newVal != null && newVal != "") {
                    this.getTelephoneValidation();

                }
                else {
                    this.messageErrorDigits = "";
                }
            },
            numDoc(newVal) {
                if (newVal == "") {
                    document.getElementById("StepText").textContent = "Datos personales";
                    document.getElementById("Siguiente").style.visibility = "hidden";
                    if (document.getElementsByClassName("btn btn-lg btn btn-secondary-outline disabled not-allowed").length > 0) {
                        document.getElementsByClassName("btn btn-lg btn btn-secondary-outline disabled not-allowed")[0].className = "btn btn-lg btn btn-secondary-outline"
                        'btn btn-lg btn btn-secondary-outline';
                        document.getElementsByClassName("btn btn-lg btn btn-secondary-outline")[0].id = "Anterior";

                        var botonAnterior = document.getElementById("Anterior") as HTMLButtonElement;
                        botonAnterior.disabled = false;
                    }
                    this.activeForm = false;
                    this.activeFormPersonNoExist = false;
                    this.nacimiento = null;
                    this.areaCode = "";
                    this.telephone = "";
                    this.email = "";
                    this.age = "0";
                    this.selectedLocality = null;
                    this.streetName = null;
                    this.numDept = null;
                    this.numDom = null;
                    this.piso = null;
                    this.gender = null;
                    this.genderId = null;
                    this.isPersonExist = true;
                    this.isNotSelectedDocumentType = false;
                    this.firstName = "";
                    this.lastName = "";
                    this.hasLocality = false;
                    NF.UI.Page.unblock();
                }
            }
        },

        mounted() {
            window.globalThis.dataLayer = window.globalThis.dataLayer || [];
            NF.UI.Page.block();
            this.Bus.$on('get-step-one-data', () => this.Bus.$emit('step-one-data', this.$data))
            sessionStorage.setItem("ExitOrContinueModal", "true")
            this.getDocumentType();
        }
    });
